export const ORDER_CREATE_REQUEST = "ORDER_CREATE_REQUEST";
export const ORDER_CREATE_SUCCESS = "ORDER_CREATE_SUCCESS";
export const ORDER_CREATE_FAILS = "ORDER_CREATE_FAILS";

export const ORDER_CREATE_RESET = "ORDER_CREATE_RESET";

export const ORDER_DETAILS_REQUEST = "ORDER_DETAILS_REQUEST";
export const ORDER_DETAILS_SUCCESS = "ORDER_DETAILS_SUCCESS";
export const ORDER_DETAILS_FAILS = "ORDER_DETAILS_FAILS";

export const ORDER_PAY_REQUEST = "ORDER_PAY_REQUEST";
export const ORDER_PAY_SUCCESS = "ORDER_PAY_SUCCESS";
export const ORDER_PAY_FAILS = "ORDER_PAY_FAILS";
export const ORDER_PAY_RESET = "ORDER_PAY_RESET";

export const ORDER_LIST_MY_REQUEST = "ORDER_LIST_MY_REQUEST";
export const ORDER_LIST_MY_SUCCESS = "ORDER_LIST_MY_SUCCESS";
export const ORDER_LIST_MY_FAILS = "ORDER_LIST_MY_FAILS";

export const ORDER_LIST_MY_RESET = "ORDER_LIST_MY_RESET";

export const ORDER_LIST_ALL_REQUEST = "ORDER_LIST_ALL_REQUEST";
export const ORDER_LIST_ALL_SUCCESS = "ORDER_LIST_ALL_SUCCESS";
export const ORDER_LIST_ALL_FAILS = "ORDER_LIST_ALL_FAILS";
export const ORDER_LIST_ALL_RESET = "ORDER_LIST_ALL_RESET";

export const ORDER_DELIVERED_REQUEST = "ORDER_DELIVERED_REQUEST";
export const ORDER_DELIVERED_SUCCESS = "ORDER_DELIVERED_SUCCESS";
export const ORDER_DELIVERED_FAILS = "ORDER_DELIVERED_FAILS";
export const ORDER_DELIVERED_RESET = "ORDER_DELIVERED_RESET";
